import Clipboard from 'clipboard';

/**
 * 获取url中的参数值
 * @param {String} param url中的参数key
 * @returns url中的参数value
 */
const getUrlParam = (param) => {
    return new URL(window.location.href).searchParams.get(param);
}


/**
 * 一键复制
 * <button class="copyBtn" data-clipboard-text="复制的文本内容" data-tag="埋点">复制</button>
 * @param {String| Element | NodeListOf<Element>} selector 元素选择器
 * @param {String} popTips 弹窗提示文案
 */
const oneClickCopy = (selector, popTips) => {
    const clipboard = new Clipboard(selector);
    clipboard.on('success', function(e) {
        tar.hitTag(`复制口令_${e.trigger.dataset.tag}`);
        weui.alert(popTips);
    });
}


/**
 * 长按扫码
 * <img class="qrcode" data-tag="埋点" src="#" alt="">
 * @param {String} selector css选择器
 */
const scanQRcode = (selector) => {
    const elementArr = document.querySelectorAll(selector);
    if (elementArr.length > 0) {
        for (const element of elementArr) {
            let startTime, endTime;
            const func = function() {
                endTime = new Date().getTime();
                if ((endTime - startTime) / 1000 >= 0.3) {
                    tar.hitTag(`长按扫码_${this.dataset.tag}`);
                }
                startTime = endTime = 0;
            }
            element.addEventListener("touchstart", function() {
                startTime = new Date().getTime();
            });
            element.addEventListener("touchend", func);
            element.addEventListener("touchcancel", func);
        }
    }
}


/**
 * 点击跳转
 * <button class="tolink" data-link="跳转链接" data-tag="埋点">跳转</button>
 * @param {String} selector css选择器
 * @param {String} showguide 遮罩引导文案(可选，不填直接跳转)
 */
const tolink = (selector, showguide) => {
    const showShadow = () => {
        const shadow = document.createElement('div');
        const shadow_arrow = document.createElement('div');
        const shadow_content = document.createElement('div');
        const shadow_tips = document.createElement('div');
        shadow.className = 'shadow';
        shadow_arrow.className = 'shadow_arrow';
        shadow_content.className = 'shadow_content';
        shadow_tips.className = 'shadow_tips';
        // shadow_arrow.innerHTML = '<img src="http://h5cdn.tarsocial.com/taobao/elf/dist/img/arrow.png">';
        shadow_arrow.innerHTML = `<img src="${require('../img/share_tip.png').default}">`;
        // shadow_arrow.innerHTML = `<img src="http://h5cdn.tarsocial.com/taobao/elf/dist/img/arrow.png">`;
        // shadow_content.innerHTML = `<div>${showguide}</div>`;
        // shadow_tips.innerHTML = `选择在${/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)?'safari':'浏览器'}中打开`;
        shadow.appendChild(shadow_arrow);
        // shadow.appendChild(shadow_content);
        shadow.appendChild(shadow_tips);
        document.body.appendChild(shadow);
        shadow.addEventListener('click', function() {
            document.body.removeChild(this);
        });
    }
    const elementArr = document.querySelectorAll(selector);
    if (elementArr.length > 0) {
        for (const element of elementArr) {
            element.addEventListener('click', function() {
                const ua = navigator.userAgent.toLowerCase();
                tar.hitTag(showguide || '召好友抢福利');
                showShadow();
                // if (ua.match(/MicroMessenger/i) == "micromessenger" && showguide) {
                //     tar.hitTag('显示引导遮罩');
                //     showShadow();
                // } else {
                //     tar.hitTag(`跳转链接_${this.dataset.tag}`);
                //     setTimeout(() => {
                //         window.location.href = this.dataset.link;
                //     }, 300);
                // }
            });
        }
    }
}


/**
 * 跳转小程序
 * <button class="weapp" data-tag="埋点" data-username="小程序原始id" data-path="跳转路径">跳转小程序</button>
 * @param {String} selector css选择器
 */
const toweapp = (selector) => {
    const weapps = document.querySelectorAll(selector);
    if (weapps.length > 0) {
        for (const weapp of weapps) {
            const generateWeapp = () => {
                const [
                    width, height, left, top
                ] = [
                    weapp.offsetWidth, weapp.offsetHeight, weapp.offsetLeft, weapp.offsetTop
                ];
                const divweapp = document.createElement('div');
                divweapp.setAttribute('style', `position:${window.getComputedStyle(weapp, null).getPropertyValue("position")=='fixed'?'fixed':'absolute'};width:${width}px;height:${height}px;left:${left}px;top:${top}px;overflow:hidden;`);
                divweapp.innerHTML = `<wx-open-launch-weapp data-tag="${weapp.dataset.tag}" username="${weapp.dataset.username}" path="${weapp.dataset.path}"><template><style>.btn { width: 750px;height: 1448px;opacity: 0;  }</style><button class="btn">打开小程序</button></template></wx-open-launch-weapp>`;
                weapp.parentNode.appendChild(divweapp);
                divweapp.firstChild.addEventListener('launch', function() {
                    tar.hitTag(`跳转小程序_${this.dataset.tag}`);
                });
            }
            if (weapp.tagName.toLocaleLowerCase() === 'img') {
                if (weapp.complete) {
                    generateWeapp();
                } else {
                    weapp.onload = function() {
                        generateWeapp();
                    };
                }
            } else {
                generateWeapp();
            }
        }
    }
}


/**
 * 添加背景音乐
 * @param {String} src 资源路径
 * @param {Boolean} autoplay 是否自动播放
 */
const addBgm = (src, autoplay) => {
    const bgm = document.createElement('div');
    bgm.className = 'bgm-icon';
    const img = document.createElement('img');
    const audio = document.createElement('audio');
    audio.src = src;
    audio.style.display = 'none';
    if (autoplay) {
        img.src = 'https://h5cdn.tarsocial.com/common/img/music.png';
        img.className = 'bgm-animate';
        audio.autoplay = true;
    } else {
        img.src = 'https://h5cdn.tarsocial.com/common/img/nomusic.png';
    }
    bgm.appendChild(img);
    bgm.appendChild(audio);
    document.body.appendChild(bgm);
    bgm.addEventListener('click', function() {
        if (audio.paused) {
            img.src = 'https://h5cdn.tarsocial.com/common/img/music.png';
            img.className = 'bgm-animate';
            audio.play();
        } else {
            img.src = 'https://h5cdn.tarsocial.com/common/img/nomusic.png';
            img.className = '';
            audio.pause();
        }
    });
}


/**
 * 禁止屏幕下拉
 * prohibitDropdown();
 */
const prohibitDropdown = () => {
    document.body.addEventListener('touchmove', function(e) {
        if (!document.querySelector('div').contains(e.target)) { // 需要过滤的div
            e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
            e.preventDefault();
        }
    }, { passive: false }); //passive 参数不能省略，用来兼容ios和android
}


/**
 * 项目下线
 * @param {String} dateTime 下线时间，如：'2022/01/12 00:00:00'
 */
const offline = (dateTime) => {
    if (new Date().getTime() > new Date(dateTime).getTime()) {
        window.location.href = "https://h5cdn.tarsocial.com/common/html/end.html";
    }
}

export const tools = { getUrlParam, oneClickCopy, scanQRcode, tolink, toweapp, addBgm, prohibitDropdown, offline };
